module.exports = __webpack_public_path__ + "img/emoticon.a70c5db9.png";